<!-- <dx-button
  *ngIf="isSysAdmin"
  stylingMode="contained"
  [text]="workingModeText"
  type="normal"
  (onClick)="changeWorkingMode()"
>
</dx-button> -->

<dx-dashboard-control
  style="display: block; width: 100%"
  endpoint="api/bidashboard"   
  [workingMode]="workingMode"
  limitVisibleDataMode="DesignerAndViewer"
>
  <dxo-fetch-remote-service [headers]="headers" ></dxo-fetch-remote-service>
</dx-dashboard-control>

<app-input-popup description="Dashboard Name:"></app-input-popup>
